import { Box, Typography, useTheme ,Stack,Button,IconButton} from "@mui/material";
import { GridColumns,
  GridCellParams,
  GridRowsProp,
  DataGrid,
  GridCellModesModel,
  GridCellModes} from "@mui/x-data-grid";
import { tokens } from "../../../../theme";
import Header from "../../../../components/global/Header";
import React, { useState, useEffect,useMemo } from 'react';
import NiceDate from "../../../../components/global/NiceDate";
import { useDispatch, useSelector } from "react-redux";
import {getCollections} from "../../../../slices/collection"
import { setMessage , clearMessage} from "../../../../slices/message"
import DeleteIcon from '@mui/icons-material/Delete';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import CheckIcon from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from "react-router-dom";
import InfoIcon from '@mui/icons-material/Info';
import NiceUser from "../../../../components/global/NiceUser";
import NiceCollection from "../../../../components/global/NiceCollection";

const CollectionList = () => {
  const navigate = useNavigate();

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const dispatch = useDispatch();

  const collections = useSelector((state) => state.collection);

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);


  useEffect(() => {

    dispatch(getCollections({page,pageSize}));

}, [page,pageSize]);

const processRowUpdate = React.useCallback(
  async (newRow) => {
    // Make the HTTP request to save in the backend
    //debugger
    const id = newRow.id;
    const isBlocked = newRow.isBlocked;

    //dispatch(updateSession({id,isBlocked}));

    return newRow;
  },
  [collections],
);

const handleRowClick = (params) => {
  navigate("/admin/collection/" + params.id);
};

const handleProcessRowUpdateError = React.useCallback((error) => {
  

  dispatch(setMessage("Error editing collection"));
}, []);


  const columns = [
    { 
      field: "id", 
      headerName: "Collection ID" ,
    },
    { 
      field: "name", 
      headerName: "Name" ,
      flex: 1,
    },
    { 
      field: "description", 
      headerName: "Full Description" ,
      flex: 1,
    },
    {
      field: "administrator",
      headerName: "Administrator",
      type:"string",
      flex: 1,
      renderCell: ({row: {administrator}}) => {

        return (
          <NiceUser>{administrator}</NiceUser>
        )
      }

    },
    {
      field: "parentCollection",
      headerName: "Belongs to",
      type:"string",
      flex: 1,
      renderCell: ({row: {parentCollection}}) => {

        return (
          <>
          {parentCollection &&
            <NiceCollection>{parentCollection}</NiceCollection>
          }
          </>
        )
      }

    },
    {
      field: "Signs",
      headerName:"Signs",
    },
    {
      field: "createdAt",
      headerName: "Created",  
      type:"dateTime",
      flex: 1,
      renderCell: ({row: {createdAt}}) => {

        return (
          <NiceDate>{createdAt}</NiceDate>
        )
      }
    },


  ];

  return (

    <Box m="20px">

      <Header title="Collections" subtitle="List of collections" />

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >

          <DataGrid  experimentalFeatures={{newEditingApi: true }}
            onRowClick={handleRowClick}
            processRowUpdate={processRowUpdate}
            onProcessRowUpdateError={handleProcessRowUpdateError}
            rows={collections.data.list} 
            columns={columns} 
            pageSize={pageSize}
            page={collections.data.page}
            rowsPerPageOptions={[10, 25,50,100]}
            paginationMode="server"
            rowCount={collections.data.total}
            onPageChange={(newPage) => setPage(newPage)}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          />    

      </Box>
    </Box>
  );
};

export default CollectionList;
